import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/Menu'
import Toppart from '../pages/toppart'
import DirectpayIssue from '../pages/directpayissue'
import Footer from '../pages/Footer'

export default function DirectPay() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<DirectpayIssue />
			<Footer />	
		</div>	
	)
}
		